function createAction<P>(type: string, payload?: P, meta: any = {}): Action<P> {
  return {
    type,
    ...(payload ? { payload } : null),
    meta,
  };
}

function createOptimisticAction<P, T>(
  type: string,
  payload?: P,
  meta: Meta<T>,
): OptimisticAction<P, T> {
  return {
    type,
    ...(payload ? { payload } : null),
    meta,
  };
}

export { createOptimisticAction };
export default createAction;
